import {
    CONTABLE_COMPROBANTES_REQUEST,
    CONTABLE_COMPROBANTES_SUCCESS,
    CONTABLE_COMPROBANTES_ERROR,
    CONTABLE_COMPROBANTES_CLEAR
} from '../types/contableComprobantesTypes';
import  {httpRepo}  from 'configurations/axios';
import { getRUCEmpresa } from './userActions';

const API_MODULO_CONTABLE_COMPROBANTES = '/modulo/contable/comprobantes/';

/**
 * Comprobantes autorizados por rango ini/fin (endpoint legacy de busqueda).
 *
 * @param {Object} requestConfig
 * @param {string} requestConfig.uri          Ej: "/comprobantes/autorizados/busqueda/"
 * @param {string} requestConfig.rucEmpresa   Token del usuario (se extrae el RUC)
 * @param {number} requestConfig.page
 * @param {number} requestConfig.elementos
 * @param {string} [requestConfig.ini]
 * @param {string} [requestConfig.fin]
 * @param {string|null} [requestConfig.type]  codigoComprobante ("01", "04", etc.)
 * @param {string} [requestConfig.sort]
 */
export function getComprobantesContableAction(requestConfig) {
    return async (dispatch) => {
        dispatch(getComprobantes());
        const queryParams = [
            `page=${requestConfig.page}`,
            `size=${requestConfig.elementos}`,
            requestConfig.ini ? `ini=${requestConfig.ini}` : null,
            requestConfig.fin ? `fin=${requestConfig.fin}` : null,
            requestConfig.type ? `codigoComprobante=${requestConfig.type}` : null,
            requestConfig.sort ? `sort=${requestConfig.sort}` : null,
        ].filter(Boolean).join("&");

        await httpRepo.get(`${requestConfig.uri}${getRUCEmpresa(requestConfig.rucEmpresa)}?${queryParams}`,
            ).then(
                response => {
                    if (response.status <= 201) {
                        dispatch(getComprobantesSuccess(response.data));
                    }
                }
            ).catch(exception => {
                if (exception.response) {
                    console.error('error comprobantes contable', exception.response?.data);
                } else {
                    console.error('error comprobantes contable', exception);
                }
                dispatch(comprobantesError(true));
            }
            );
    }
}

/**
 * Version dedicada al modulo contable (Dashboard, Facturas, Notas de
 * Credito, Pagos & Cobros). Llama a GET /modulo/contable/comprobantes/{ruc}
 * con anio/mes (enteros), que devuelve un Page ya filtrado por mes.
 *
 * @param {Object} requestConfig
 * @param {string} requestConfig.rucEmpresa  Token del usuario (se extrae el RUC)
 * @param {number} requestConfig.page
 * @param {number} requestConfig.elementos
 * @param {number} [requestConfig.anio]
 * @param {number} [requestConfig.mes]
 * @param {string|null} [requestConfig.type]  codigoComprobante ("01", "04", etc.)
 * @param {string} [requestConfig.fechaInicio]  Busqueda avanzada "yyyy-MM-dd", manda sobre anio/mes
 * @param {string} [requestConfig.fechaFin]     Busqueda avanzada "yyyy-MM-dd"
 * @param {string} [requestConfig.secuencial]
 * @param {string} [requestConfig.parametroReceptor]  RUC/cedula/razon social
 */
export function getComprobantesModuloContableAction(requestConfig) {
    return async (dispatch) => {
        dispatch(getComprobantes());

        const queryParams = [
            `page=${requestConfig.page}`,
            `size=${requestConfig.elementos}`,
            requestConfig.anio ? `anio=${requestConfig.anio}` : null,
            requestConfig.mes ? `mes=${requestConfig.mes}` : null,
            requestConfig.type ? `codigoComprobante=${requestConfig.type}` : null,
            requestConfig.fechaInicio ? `fechaInicio=${requestConfig.fechaInicio}` : null,
            requestConfig.fechaFin ? `fechaFin=${requestConfig.fechaFin}` : null,
            requestConfig.secuencial ? `secuencial=${requestConfig.secuencial}` : null,
            requestConfig.parametroReceptor
                ? `parametroReceptor=${encodeURIComponent(requestConfig.parametroReceptor)}`
                : null,
        ].filter(Boolean).join("&");

        await httpRepo.get(
            `${API_MODULO_CONTABLE_COMPROBANTES}${getRUCEmpresa(requestConfig.rucEmpresa)}?${queryParams}`,
        ).then(
            response => {
                if (response.status <= 201) {
                    dispatch(getComprobantesSuccess(response.data));
                }
            }
        ).catch(exception => {
            if (exception.response) {
                console.error('error comprobantes modulo contable', exception.response?.data);
            } else {
                console.error('error comprobantes modulo contable', exception);
            }
            dispatch(comprobantesError(true));
        });
    }
}

const getComprobantes = () => ({
    type: CONTABLE_COMPROBANTES_REQUEST,
    payload: true
});

const getComprobantesSuccess = (comprobantes) => ({
    type: CONTABLE_COMPROBANTES_SUCCESS,
    payload: comprobantes
});

const comprobantesError = (estado) => ({
    type: CONTABLE_COMPROBANTES_ERROR,
    payload: estado
});

export const clearComprobantesContableAction = () => ({
    type: CONTABLE_COMPROBANTES_CLEAR
});
